interface ILocation {
  latitude: number;
  longitude: number;
}

interface IAirport {
  iataCode: string;
  cityName: string;
  location: ILocation;
  popularity: number;
}

export interface IRecommend {
  departureCity: IAirport;
  arrivalCity: IAirport;
  stops: number;
  duration: number;
  fare: number;
  isDomestic: boolean;
  sdate1: string;
  sdate2: string;
  cityImage: string;
  roundTripTime: number;
}

export interface IData {
  recommend: { count: number; list: IRecommend[] };
}

export enum FilterModalSection {
  MODAL_TOP = 'modalTop',
  DEPART_MONTH = 'departMonth',
  REGION = 'region',
  REQUIRED_TIME = 'requiredTime',
  TRAVEL_PERIOD = 'travelPeriod',
  PRICE = 'price',
}
